module.exports = __webpack_public_path__ + "img/background-video-slider-cjdr.84d54446.jpg";